import styled from "@emotion/styled";
import { FC } from "react";

import { DesignToken, ProgressCircle, SpacingToken, Text } from "@livechat/design-system-react-components";

import { useWelcomeTutorialSteps } from "hooks/use-welcome-tutorial-steps";
import { withVar } from "themes/helpers";

import { WelcomeTutorialStep } from "../helpers";

interface IProps {
  step: WelcomeTutorialStep;
}

export const StepCounter: FC<IProps> = ({ step }) => {
  const steps = useWelcomeTutorialSteps();
  const currentStep = steps.indexOf(step) + 1;
  const stepsCount = steps.length;

  return (
    <Wrapper>
      <StepCircle step={currentStep} stepsCount={stepsCount} />
      <Text customColor={withVar(DesignToken.ContentBasicSecondary)}>
        Step {currentStep} of {stepsCount}
      </Text>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${withVar(SpacingToken.Spacing2)};
`;

const getFillPercentage = (step: number, stepsCount: number): number => {
  return (step / stepsCount) * 100;
};

const StepCircle = ({ step, stepsCount }: { step: number; stepsCount: number }): JSX.Element => {
  return <StyledProgressCircle progressValue={getFillPercentage(step, stepsCount)} size="small" />;
};

const StyledProgressCircle = styled(ProgressCircle)`
  width: 24px;
  height: 24px;
`;
